import request from '@/utils/request'
import { Message } from 'element-ui';
export function getUserInfo(token) {
    // return request({
    //     url: '///',
    //     method: 'get',
    //     params: { token }
    // })
}

export function getTaskProgress(){
    return request({
        url: '/v1/api/safe/annotate/validate/tags/process/list',
        method: 'post'
    })
}


// WEBPACK FOOTER //
// ./src/api/login.js